<script setup>
import { ref, computed } from 'vue'
import { useDialogPluginComponent } from 'quasar'
import { getI18n } from '@/plugins/i18n'

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  message: {
    type: String,
    default: null,
  },
  icon: {
    type: String,
    default: null,
  },
  iconColor: {
    type: String,
    default: 'primary',
  },
  inputLabel: {
    type: String,
    default: null,
  },
  checkLabel: {
    type: String,
    default: null,
  },
  okLabel: {
    type: String,
    default: null,
  },
  okColor: {
    type: String,
    default: 'primary',
  },
})

defineEmits([...useDialogPluginComponent.emits])

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

const i18n = getI18n()

const text = ref('')
const checked = ref(false)

const isValid = computed(() => (!props.inputLabel || !!text.value.trim()) && (!props.checkLabel || checked.value))

const onConfirm = () => {
  if (isValid.value) onDialogOK(props.inputLabel ? text.value.trim() : true)
}
</script>

<template>
  <q-dialog
    ref="dialogRef"
    persistent
    class="dialog-xxs"
    @hide="onDialogHide"
  >
    <q-card>
      <q-card-section class="row items-center no-wrap">
        <q-avatar
          v-if="props.icon"
          :icon="props.icon"
          :color="props.iconColor"
          text-color="white"
        />
        <div class="text-h6" :class="{ 'q-ml-sm': props.icon }">{{ props.title }}</div>
      </q-card-section>
      <q-card-section v-if="props.message" class="q-pt-none">
        {{ props.message }}
      </q-card-section>
      <q-card-section v-if="props.inputLabel" class="q-pt-none">
        <q-input
          v-model="text"
          :label="props.inputLabel"
          outlined
          autogrow
          autofocus
        />
      </q-card-section>
      <q-card-section v-if="props.checkLabel" class="q-pt-none">
        <q-checkbox v-model="checked" class="items-start" :label="props.checkLabel" />
      </q-card-section>
      <q-card-actions align="right">
        <q-btn flat :label="i18n.t('common.cancel')" @click="onDialogCancel" />
        <q-btn
          flat
          :color="props.okColor"
          :label="props.okLabel || i18n.t('common.confirm')"
          :disable="!isValid"
          @click="onConfirm"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
